var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdmSepPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E3E8",
    d: "M2.828.172L5.656 3 2.828 5.83 0 3z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIyLjgyODEyIiB5PSIwLjE3MTg3NSIgd2lkdGg9IjQiIGhlaWdodD0iNCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMi44MjgxMiAwLjE3MTg3NSkiIGZpbGw9IiNFMUUzRTgiLz4KPC9zdmc+Cg==";
export { SvgEdmSepPreview as ReactComponent };